import React, { useEffect, useState } from 'react';
import { replayAfterMfa } from 'api';
import { PopupOrPanel } from 'components/popupsAndPanels/PopupAndPanels';
import { rejectHeldRequests, subscribeToMfaGate } from 'helpers/mfa/mfaGate';
import { useToastMessage } from 'hooks/useToast';
import {
  MFA_SET_UP_MESSAGE,
  MfaGrantResult,
  describeMfaGrant,
} from 'pages/mfa/models';
import { MfaChallenge } from './MfaChallenge';

export const MfaChallengeModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const showToast = useToastMessage();

  useEffect(() => subscribeToMfaGate(setOpen), []);

  const handleVerified = (result: MfaGrantResult | null, setUp: boolean) => {
    replayAfterMfa();
    const grant = result ? describeMfaGrant(result) : '';
    const message = setUp ? `${MFA_SET_UP_MESSAGE} ${grant}`.trim() : grant;
    if (message) showToast(message);
  };

  if (!open) return null;

  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={open}
      position="right"
      hdrTitle=""
      noHeader
      noContentContainer
      noFooter
      givenClass="MfaChallengeModal"
      handleClose={rejectHeldRequests}
      width={460}
    >
      <MfaChallenge
        mode="verify"
        layout="modal"
        onComplete={handleVerified}
        onCancel={rejectHeldRequests}
      />
    </PopupOrPanel>
  );
};

export default MfaChallengeModal;
